import { createElement } from 'react';
import { Cell } from '@alifd/layout';
import './index.scss';
const OadpBusinessForm = function OadpBusinessForm({ width, height, autoFit, gap, direction, align, verAlign, block, children, name, label, placeholder, defaultValue, required, disabled, ...otherProps }) {
    return (createElement(Cell, Object.assign({ width: width, height: height, autoFit: autoFit, gap: gap, direction: direction, align: align, verAlign: verAlign, block: block, children: children }, otherProps)));
};
export default OadpBusinessForm;
